import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { getPathVariables } from '../misc';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';

const useFetchContentfulData = key => {
  const locale = getPathVariables(window.location.pathname)[0];

  const config = {
    ...contentfulFormConfig,
    content_type: key,
    locale
  };
  const [data, setData] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    if (key) {
      getContentfulData(config)
        .then(res => {
          setData(getData(res));
        })
        .catch(err => {
          setError(err);
        });
    }
  }, []);

  return {
    data,
    error
  };
};

useFetchContentfulData.propTypes = {
  key: PropTypes.string.isRequired
};

export default useFetchContentfulData;
